import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../components";
import * as localComponents from "./components";

import "./styles.css";

import imageAnnuityPopupFebruary from "./components/HomePopup/images/annuity-popup-february.png";
import imageAnnuityPopupMarch from "./components/HomePopup/images/annuity-popup-march.png";
import imageIrregularRecord from "./components/HomePopup/images/irregular-record-popup.jpeg";

export default function Home() {
  const { accessType } = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupImage, setPopupImage] = useState(null);
  const [popupLink, setPopupLink] = useState("");

  if (accessType !== "home_profissional" && accessType !== "home") {
    window.location.pathname = "/";
  }

  const type =
    accessType === "home_profissional" ? "Profissional" : "Não Profissional";

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    // if year is 2026 and month is February or March, show the popup
    if (currentYear === 2026) {
      const currentMonth = currentDate.getMonth() + 1; // getMonth returns 0-11

      if (currentMonth === 2 || currentMonth === 3) {
        setPopupTitle("Anuidade Profissional");
        setPopupImage(
          currentMonth === 2
            ? imageAnnuityPopupFebruary
            : imageAnnuityPopupMarch,
        );
        setPopupLink(`/${accessType}/conteudo/7251`);
      } else {
        setPopupTitle("Regularize seu cadastro");
        setPopupImage(imageIrregularRecord);
        setPopupLink(`/${accessType}/conteudo/parcelamento_de_dividas_6416`);
      }

      const timer = setTimeout(() => setShowPopup(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [accessType]);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showPopup]);

  return (
    <>
      <globalComponents.Header />

      <div className="bg-home">
        <div className="container">
          <div className="row">
            <localComponents.HomeBreadcrumb type={type} />
          </div>

          <div className="row">
            <div className="col">
              <div className="row" style={{ marginTop: "35px" }}>
                <div className="col-md-9 col-sm-12">
                  <localComponents.HomeCarousel />
                </div>
                <div className="col-md-3 col-sm-12">
                  <localComponents.Agenda />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="highlightsContainer">
        <localComponents.Highlights />
      </div>

      <div className="mostSearchedContainer">
        <localComponents.MostSearchedServices type={type} />
      </div>

      <div className="newsBlockContainer">
        <localComponents.NewsBlock />
      </div>

      <div className="linksDisplayContainer">
        <localComponents.LinksDisplay />
      </div>

      <div className="officesLocationsContainer">
        <localComponents.OfficesLocations />
      </div>

      <div className="publicationsBlockAndMagazinesListContainer">
        <localComponents.PublicationsBlock />

        {/* <localComponents.MagazinesList /> */}
      </div>

      <localComponents.HomeFooter />

      {showPopup && (
        <localComponents.HomePopup
          onClose={() => setShowPopup(false)}
          title={popupTitle}
          image={popupImage}
          link={popupLink}
        />
      )}
    </>
  );
}
